import React from "react";
import { Task } from "../../../types";
import { useQuestContext } from "../../../context/QuestContext";
import { replaceHyperlinks } from "../../../utils/hyperlink";

export interface GraphProps {
  data: Task;
}

const Graph: React.FC<GraphProps> = ({ data }) => {
  const { tasksCompleted } = useQuestContext();

  const isTaskComplete = tasksCompleted.includes(data?.id);
  return (
    <div className="bad-quest__task">
      <p className="bad-quest__task--description">
        {replaceHyperlinks(data.description)}
      </p>
      {/* {isTaskComplete && <p className="task_task_complete">Completed</p>} */}
    </div>
  );
};

export { Graph };
